export class PersonAttributeType {
    id = null;
    code = null;
    name = null;
    description = null;
    // voided = null;
}